<template>
  <div class="detail-list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DetailList"
};
</script>

<style lang="scss" scoped>
.detail-list {
  width: 400px;
}

h2 {
  margin-bottom: 20px;
}
</style>
